<div class="card">
    <div class="rewards-back"></div>
    <div class="data-binder">
        <table>
            <tr>
                <th *ngFor="let header of rewards.headers">
                    <div [ngClass]="header?.classes?.mainHeaderClass">
                        <p *ngIf="header.heading" [ngClass]="header?.classes?.headingClass">
                            {{ header.heading }}
                        </p>
                        <hr *ngIf="header.hasHorizontalRow" [ngClass]="header?.classes?.hrClass" />
		        <p *ngIf="header.subHeading" [innerHTML]="header.subHeading | safeHtml: 'html'" [ngClass]="header?.classes?.subHeadingClass">
                        </p>
                        <div [ngClass]="header?.classes?.imageClass" *ngIf="(header?.imageEn)[0] || (header?.imageFr)[0]">
                            <img [src]="
                  (header?.imageEn)[0]?.file?.publicUrl ||
                    (header?.imageFr)[0]?.file?.publicUrl | safeHtml: 'url'
                " [alt]="
                  (header?.imageEn)[0]?.name || (header?.imageFr)[0]?.name
                " />
                        </div>
                    </div>
                </th>
            </tr>
            <tbody>
                <ng-container class="sub-header" *ngIf="rewards.rows.length">
                    <tr class="table-row" *ngFor="let row of rewards.rows">
                        <td class="table-main-heading" *ngIf="row.showCategoryLabel && !isArray(row); else categoryItem" [attr.colspan]="row?.colSpan || rewards.headers.length">
                            {{ row.label }}
                        </td>
                        <ng-template #categoryItem>
                            <td class="table-cell" *ngFor="let data of row; index as columnIndex" [attr.colspan]="data?.colSpan || 0" [style]="data?.style | safeHtml: 'style'">
                                <div class="heading" *ngIf="data?.rewardType?.priority === 1">
                                    {{ data.key }}
                                </div>
                                <div class="range" *ngIf="
                    data.percentageValue && data?.rewardType?.priority !== 1
                  ">
                                    {{ data.percentageValue }}
                                </div>
                                <ng-container *ngIf="
                    !data.percentageValue &&
                    data.value &&
                    data?.rewardType?.priority !== 1
                  " [ngSwitch]="data.value">
                                    <div class="range-tick not-translate" *ngSwitchCase="'check'">
                                        <mat-icon [style]="data?.rewardType?.style | safeHtml: 'style'">check</mat-icon>
                                    </div>
                                    <div class="range-tick-uncheck not-translate" *ngSwitchCase="'uncheck'">
                                        <!-- <mat-icon
                      [style]="data?.rewardType?.style | safeHtml: 'style'"
                      >check</mat-icon
                    > -->
                                    </div>
                                </ng-container>
                            </td>
                        </ng-template>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <div class="footer-text">
            <p [innerHTML]="rewards.rewardsFooter | safeHtml: 'html'"></p>
        </div>
    </div>
</div>
